import { render, staticRenderFns } from "./ColorMgmt.vue?vue&type=template&id=4b814897"
import script from "./ColorMgmt.vue?vue&type=script&lang=js"
export * from "./ColorMgmt.vue?vue&type=script&lang=js"
import style0 from "./ColorMgmt.vue?vue&type=style&index=0&id=4b814897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports